<template>
  <div class="bg-foundation-laranja">
    <CarouselControlsHorizontal
      :title="title"
      :show-arrow="false"
      :show-navigation="true"
      :infinite="true"
      :autoplay="{ delay: 6000 }"
      :button="button"
      dots-class="md:hidden"
      bg-color="pr-0 sm:pr-0 lg:pr-0"
      dots-active-color="var(--color-foundation-verde1)"
      dots-color="var(--color-neutral-6)"
      dots-background-color="rgba(249, 249, 245, 0.5)"
      title-container="items-center"
      :class-names="{ root: 'container' }"
      :items="items"
      :custom-breakpoints="carouselBreakpoints"
    />
  </div>
</template>

<script setup lang="ts">
import CarouselControlsHorizontal from '../CarouselControlsHorizontal/CarouselControlsHorizontal.vue'
import type { CardGeneric as CardGenericType } from '~/types/cards'
import type { ButtonProps } from '~/components/atoms/ButtonV2'

const props = defineProps<{
  title: string
  items: CardGenericType[]
  button: ButtonProps
}>()

const carouselBreakpoints = {
  0: {
    slidesPerView: 'auto',
    spaceBetween: 24
  },
  640: {
    slidesPerView: 'auto',
    spaceBetween: 24
  },
  1024: {
    slidesPerView: 'auto',
    spaceBetween: 24
  }
} as const
</script>
